import dynamic from 'next/dynamic'
import Image from 'next/image'
import React from 'react'
import { cn } from 'utils'

import SectionContent from '../../components/SectionContent'
import SectionLayout from '../../components/SectionLayout'
import { BootcampsType } from '../../data/bootcampsData'
import { VideoSectionData } from '../../data/videoSection'

const ReactPlayerDynamic = dynamic(() => import('react-player/youtube'), {
  ssr: false
})

const VideoSection = (props: {
  showLearnWith: boolean
  type: BootcampsType
}) => {
  const { showLearnWith = true, type } = props
  return (
    <div
      style={{
        background: showLearnWith
          ? 'linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.00) 100%)'
          : 'none'
      }}>
      <SectionLayout className={cn('max-w-7xl mx-auto')}>
        <SectionContent className="flex-nowrap flex-col sm:flex-row sm:gap-10">
          {showLearnWith && (
            <div className="space-y-3">
              <p className="text-lg text-[#FFB300]">Learn With</p>
              <div className="rounded-xl w-full w-[300px]">
                <Image
                  src={VideoSectionData[type].image || ''}
                  width={350}
                  height={240}
                  alt={'kshitiz'}
                  className="w-[350px] h-[240px] rounded-xl overflow-hidden object-cover object-top"
                />
              </div>
              <div className="flex flex-col py-4">
                <p className="text-primary font-semibold text-lg md:text-xl lg:text-2xl">
                  {VideoSectionData[type].name || ''}
                </p>
                <p className="text-sm">
                  {VideoSectionData[type].firstPosition || ''}
                </p>
                {VideoSectionData[type].secondPosition && (
                  <p className="text-sm">
                    {VideoSectionData[type].secondPosition}
                  </p>
                )}
              </div>
            </div>
          )}

          <div className={cn('h-[300px] sm:h-[400px] rounded-lg sm:flex-1')}>
            <ReactPlayerDynamic
              url="https://youtu.be/bxn6QwwbRQs"
              width="100%"
              height="100%"
              controls
              class="rounded-lg"
            />
          </div>
        </SectionContent>
      </SectionLayout>
    </div>
  )
}

export default VideoSection
